import {languageTypes} from './languateTypes.js';

const INITIAL_STATE = {
  language: localStorage.getItem('lang') || languageTypes.ENGLISH,
};

const languageReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'language':
      localStorage.setItem('lang', action.payload);
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};

export default languageReducer;
